import React from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Topics from "@/components/site/Topics";
import Listen from "@/components/site/Listen";
import HowItWorks from "@/components/site/HowItWorks";
import Statement from "@/components/site/Statement";
import Modes from "@/components/site/Modes";
import Parents from "@/components/site/Parents";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
  useReveal();
  return (
    <div className="site" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Topics />
        <div style={{ height: 72 }} />
        <Listen />
        <HowItWorks />
        <Statement />
        <Modes />
        <Parents />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
